import { loc } from '@/localization';

import Checkmark from './assets/checkmark.svg?react';
import { e } from './style.css';

function Feature({ title }: { title: string }) {
    return (
        <li className={e.feature}>
            <Checkmark className={e.featureIcon} />
            <span className={e.featureTitle}>{title}</span>
        </li>
    );
}

export function Features() {
    return (
        <ul className={e.features}>
            <Feature title={loc.Registration.Feature1} />
            <Feature title={loc.Registration.Feature2} />
            <Feature title={loc.Registration.Feature3} />
            <Feature title={loc.Registration.Feature4} />
        </ul>
    );
}
